module.exports = __webpack_public_path__ + "static/media/AdventureBg.418f010f.webp";